import React from 'react'
import { Box, Typography } from '@mui/material'
import jetpacFullLogo from 'assets/brand/jetpac/jetpac-full-logo.png'

function LogInHeader() {
  return (
    <>
      <Box>
        <img
          src={jetpacFullLogo}
          alt='Jetpac Logo'
          style={{
            height: '35px'
          }}
        />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '2em', fontWeight: '900', my: 4 }}>
          Welcome to Engine
        </Typography>
      </Box>
    </>
  )
}

LogInHeader.propTypes = {}

export default LogInHeader
